<template>
  <v-container>
    <NewStayForm v-if="$route.params.formName === 'newStayForm'" />
    <ModifyStayForm
      v-if="$route.params.formName === 'modifyStayForm'"
    />
  </v-container>
</template>

<script>
import axios from "axios";
import NewStayForm from "@/components/stays/forms/NewStayForm";
import ModifyStayForm from "@/components/stays/forms/ModifyStayForm";
export default {
  components: {
    ModifyStayForm,
    NewStayForm
  },
  name: "StayForms",

  data() {
    return {
      stay: ""
    };
  },
  methods: {
    setBreadcrumb() {
      let stay = {
        text: this.stay,
        exact: true,
        href: "/stays/" + this.$route.params.id,
        last: true
      };
      let form = {
        text: "section." + this.$route.params.formName,
        disabled: true,
        last: true
      };
      if (
        !this.$route.meta.breadCrumb.some(breadcrumb => {
          return breadcrumb.last === true;
        })
      ) {
        if (this.$route.meta.update) {
          this.$route.meta.breadCrumb.push(stay);
        }
        this.$route.meta.breadCrumb.push(form);
      } else {
        this.$route.meta.breadCrumb.pop();
        if (this.$route.meta.update) {
          this.$route.meta.breadCrumb.pop();
          this.$route.meta.breadCrumb.push(stay);
        }
        this.$route.meta.breadCrumb.push(form);
      }
      this.$store.state.sectionTitle = "section." + this.$route.params.formName;
    },
    getStay() {
      if (
        this.$route.params.formName === "modifyStayForm" &&
        this.$route.meta.update
      ) {
        const path =
          this.$store.state.endpoint + "/user/stays/" + this.$route.params.id;
        axios
          .get(path)
          .then(response => {
            this.stay = this.originalStay = response.data.title;
          })
          .finally(() => {
            this.setBreadcrumb();
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.setBreadcrumb();
      }
    }
  },

  created() {
    this.getStay();
  },

  updated() {
    this.getStay();
  }
};
</script>

<style scoped></style>
